import httpService from "./httpService";

export default {
  search: async () => httpService.get("/documentroute/"),
  getDocumentStats: async () => httpService.get("/documentroute/stats"),
  getSentDocuments: async () => httpService.get("/documentroute/sent"),
  getInboxDocuments: async () => httpService.get("/documentroute/inbox"),
  getForDocumentTypePaged: async (documentTypeId, documentRouteStatusId, page = 1, pageSize = 25) => {
    const params = new URLSearchParams({ page, pageSize });
    if (documentRouteStatusId > 0) params.append("documentRouteStatusId", documentRouteStatusId);
    return httpService.get(`/documentroute/all/${documentTypeId}/paged?${params}`);
  },
  getForDocumentTypes: async documentTypeIds => httpService.get(`/documentroute/getByDocumentTypes/${documentTypeIds}`),
  getNotReturnedDivisionOrders: async () => httpService.get("/documentroute/notReturnedDOs"),
  getOwnerDocumentReceivedCountsPerDay: async () => httpService.get("/documentroute/ownerDocReceivedCounts"),
  getOwnerDocumentSentCountsPerDay: async () => httpService.get("/documentroute/ownerDocSentCounts"),
};
